/* Companio companions carousel.

   NOT FROM FIGMA. The artboard draws a single slide with one "Case 01" label
   pill and a chevron. William confirmed on 2026-08-17 that the eight case
   blocks should become a carousel, so the chevron in that pill is treated as
   the advance control the designer implied.

   SCROLL CONTAINER, NOT TRANSFORMS.
   The track is overflow-x with scroll-snap and one slide per viewport width,
   same approach as the product shelf. Consequences worth keeping:
     - with JS blocked it is still a swipeable rail, and each slide carries its
       OWN label, so nothing depends on JS to stay truthful;
     - trackpad and touch swipe work for free;
     - the label pill is inside its slide, so it can never describe the wrong
       photo, which a single JS-updated label could.

   Wrapping from the last slide back to the first jumps instead of animating.
   Smooth-scrolling backwards across eight full-width photos reads as a glitch.

   Autoplay is OFF by default. A 680px photo swapping itself under the reader is
   a different proposition from the small product row above, so it is opt-in per
   section rather than assumed.
*/
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(root) {
    if (root.dataset.compReady) return;
    root.dataset.compReady = '1';

    var track = root.querySelector('[data-comp-track]');
    if (!track || track.children.length === 0) return;

    var count = track.children.length;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-comp-dot]'));
    var status = root.querySelector('[data-comp-status]');

    var autoplay = root.dataset.compAutoplay === 'true';
    var interval = parseInt(root.dataset.compInterval, 10) || 6000;
    var timer = null;
    var syncTimer = null;
    var onScreen = true;
    var hovered = false;

    function current() {
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(target, allowSmooth) {
      var n = ((target % count) + count) % count;
      var wrapped = target >= count || target < 0;
      var smooth = allowSmooth !== false && !wrapped && !REDUCE.matches;
      track.scrollTo({
        left: n * track.clientWidth,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    function sync() {
      var i = current();
      dots.forEach(function (dot, k) {
        var on = k === i;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
        dot.tabIndex = on ? 0 : -1;
      });
      if (status) status.textContent = 'Case ' + (i + 1) + ' of ' + count;
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || REDUCE.matches) return;
      timer = setInterval(function () {
        if (hovered || !onScreen || document.hidden) return;
        goTo(current() + 1);
      }, interval);
    }

    track.addEventListener('scroll', function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(sync, 90);
    }, { passive: true });

    Array.prototype.forEach.call(root.querySelectorAll('[data-comp-next]'), function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(current() + 1);
        start();
      });
    });

    dots.forEach(function (dot, k) {
      dot.addEventListener('click', function () {
        goTo(k);
        start();
      });
    });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current() + 1); start(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current() - 1); start(); }
    });

    root.addEventListener('mouseenter', function () { hovered = true; });
    root.addEventListener('mouseleave', function () { hovered = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      }, { threshold: 0 }).observe(root);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      var i = current();
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(i, false); }, 200);
    });

    sync();
    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-comp]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
